import { EtaDistanceResult, EtaLocation } from '@/feature/eta'

import { CircleAvatar } from '@/lib/core/components/CircleAvatar'
import { Loader } from '@/lib/core/components/Loader'

import { LocationToContent } from '../LocationToContent'
import { LocationToError } from '../LocationToError'
import styles from '../Eta.module.css'

export const AssetLocationTo = ({
  etaLocation,
  etaResult,
  error,
}: {
  etaLocation: EtaLocation
  etaResult?: EtaDistanceResult
  error?: string
}) => (
  <div className={styles.locationTo}>
    <div className={styles.locationToHeader}>
      <CircleAvatar src={etaLocation.avatar} size={28} withBorder />
      <div>{etaLocation.title}</div>
    </div>
    {error ? (
      <LocationToError error={error} />
    ) : etaResult ? (
      <LocationToContent etaResult={etaResult} />
    ) : (
      <div className={styles.locationToLoading}>
        <Loader style={{ padding: '1.25rem' }} />
      </div>
    )}
  </div>
)
